import { FC, useState } from "react"
import { useParams } from "react-router-dom"
import {
  Box,
  Container,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material"
import { useTitle } from "@/core/hooks"
import { JoinJobProgress } from "../components/chats/joinJobProgress"
import { JoinJobsTable } from "../components/chats/joinJobsTable"
import { MailingsTable } from "../components/chats/mailingsTable"
import { PoolTable } from "../components/chats/poolTable"
import { MailingProgress } from "../components/chats/mailingProgress"
import { WorkflowStepper } from "../components/stepper/workflowStepper"

type ChatsTab = "pool" | "joins" | "mailings"

export const ChatsPage: FC = () => {
  useTitle("Чаты и рассылки")
  const [tab, setTab] = useState<ChatsTab>("pool")

  return (
    <Container maxWidth={false}>
      <WorkflowStepper />
      <Typography variant="h5" mb={2}>
        Чаты и рассылки
      </Typography>
      <ToggleButtonGroup
        exclusive
        size="small"
        value={tab}
        onChange={(_, v) => {
          if (v) setTab(v as ChatsTab)
        }}
        sx={{ mb: 1 }}
      >
        <ToggleButton value="pool">Чаты</ToggleButton>
        <ToggleButton value="joins">История вступлений</ToggleButton>
        <ToggleButton value="mailings">История рассылок</ToggleButton>
      </ToggleButtonGroup>
      <Box>
        {tab === "joins" ? (
          <JoinJobsTable />
        ) : tab === "mailings" ? (
          <MailingsTable />
        ) : (
          <PoolTable />
        )}
      </Box>
    </Container>
  )
}

export const JoinJobProgressPage: FC = () => {
  useTitle("Вступление")
  const { jobId = "" } = useParams<{ jobId: string }>()
  return <JoinJobProgress jobId={jobId} />
}

export const MailingProgressPage: FC = () => {
  useTitle("Рассылка")
  const { botId = "", mailingId = "" } = useParams<{
    botId: string
    mailingId: string
  }>()
  return <MailingProgress botId={botId} mailingId={mailingId} />
}
